import axios from "../../axios-config";

export const fetchMetaCampaignList = async ({ page = 1, limit = 10 } = {}) => {
    const res = await axios.get("/campaign/v1/get-meta-camapign-list", {
        params: { page, limit },
    });

    return {
        campaigns: res.data?.data ?? [],
        metaLiveDataAvailable: res.data?.metaLiveDataAvailable ?? true,
        metaTokenError: res.data?.metaTokenError ?? null,
        total: res.data?.total ?? 0,
    };
};

export const fetchMetaCampaignHistoryList = async ({
    page = 1,
    limit = 10,
    interval = "",
    effectiveStatus = "",
} = {}) => {
    const res = await axios.get("/campaign/v1/get-meta-camapign-history-list", {
        params: {
            page,
            limit,
            interval: interval || "",
            effectiveStatus: effectiveStatus || "",
        },
    });

    const body = res.data?.data ?? {};
    return {
        total: body.total ?? 0,
        page: body.page ?? Number(page),
        limit: body.limit ?? Number(limit),
        campaignList: body.campaignList ?? [],
        metaLiveDataAvailable: res.data?.metaLiveDataAvailable ?? true,
        metaTokenError: res.data?.metaTokenError ?? null,
    };
};

export const fetchMetaCampaignDetails = async (campaignId) => {
    const res = await axios.get(`/campaign/v1/get-meta-camapign-details/${campaignId}`);
    return res.data?.data ?? {};
};

export const fetchMetaCampaignAnalytics = async ({
    range = "all",
    refresh = false,
} = {}) => {
    const res = await axios.get("/campaign/v1/get-meta-campaign-analytics", {
        params: {
            range,
            ...(refresh ? { refresh: true } : {}),
        },
    });

    return (
        res.data?.data ?? {
            totals: { spend: 0, currency: null, spendUsd: 0, impressions: 0, clicks: 0, cpc: 0 },
            timeline: [],
        }
    );
};

export const fetchMetaCampaignAudienceBreakdown = async ({
    range = "all",
    refresh = false,
} = {}) => {
    const res = await axios.get("/campaign/v1/get-meta-campaign-audience-breakdown", {
        params: {
            range,
            ...(refresh ? { refresh: true } : {}),
        },
    });

    const body = res.data;
    return body?.data ?? { age: [], gender: [] };
};
